import { createRoute } from "@tanstack/react-router";
import {
  RouteErrorComponent,
  RoutePendingFallback,
} from "@/app/router/components/RouteBoundaries";
import { UnauthorizedPage } from "@/features/auth/components/UnauthorizedPage";
import { rootRoute } from "@/routes/root";

export const unauthorizedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/auth/unauthorized",
  staticData: { title: "Unauthorized" },
  component: UnauthorizedPage,
  pendingComponent: RoutePendingFallback,
  errorComponent: RouteErrorComponent,
});

